export default __webpack_public_path__ + "static/media/Global.90c0acd8.png";